import { tns } from 'tiny-slider/src/tiny-slider';
import whenDomReady from 'when-dom-ready';

// eslint-disable-next-line import/no-webpack-loader-syntax
import svgChevronRight from '!raw-loader!../../img/slider-chevron-right.svg';

function initialise() {
  let sliders = getSliderElements();

  if (!sliders.length) {
    return;
  }

  const query = window.matchMedia('(min-width: 1024px)');

  let instances = [];

  sliders.forEach((slider, index) => {
    let instance;

    if (query.matches) {
      instance = initialiseGallery(slider);
    } else {
      instance = initialiseCarousel(slider);
    }

    instances[index] = instance;
  });

  query.addEventListener('change', (event) => {
    // Destroy existing sliders.
    instances.forEach((instance) => instance.destroy());

    // Clear cached instances.
    instances = [];

    // Wait a frame, make sure that tinyslider has destroyed.
    requestAnimationFrame(() => {
      // Re-query elements, needed to reinitialise
      sliders = getSliderElements();

      // Check updated media query and re-init sliders.
      sliders.forEach((slider, index) => {
        let instance;

        if (event.matches) {
          instance = initialiseGallery(slider);
        } else {
          instance = initialiseCarousel(slider);
        }

        instances[index] = instance;
      });
    });
  });
}

whenDomReady().then(initialise);

function getSliderElements() {
  const sliders = document.querySelectorAll('.js-fifty-fifty-slider');
  return Array.from(sliders);
}

function initialiseCarousel(slider) {
  const autoplay = parseInt(slider.dataset.autoplay, 10);

  return tns({
    autoplay: !Number.isNaN(autoplay) && autoplay > 0,
    autoplayButton: false,
    autoplayButtonOutput: false,
    autoplayHoverPause: true,
    autoplayTimeout: autoplay,
    container: slider,
    gutter: 4,
    items: 1,
    controlsText: [
      `
        ${svgChevronRight}
        <span>Previous</span>
      `,
      `
        ${svgChevronRight}
        <span>Next</span>
      `,
    ],
  });
}

function initialiseGallery(slider) {
  const autoplay = parseInt(slider.dataset.autoplay, 10);

  return tns({
    animateIn: 'tns-custom-in',
    animateOut: 'tns-custom-out',
    autoplay: !Number.isNaN(autoplay) && autoplay > 0,
    autoplayButton: false,
    autoplayButtonOutput: false,
    autoplayHoverPause: true,
    autoplayTimeout: autoplay,
    container: slider,
    controls: false,
    items: 1,
    mode: 'gallery',
    speed: 600,
  });
}
